<template>
  <div class="pad-all lvc-share">
    <p class="mar-top-0 text-hv">分享直播</p>
    <div v-show="password" class="mar-top">
      <p class="text-sm">直播密码：{{password}}
        <van-icon name="eye-o" @click="handleLvcInfo('look')"/>
        <span class="text-primary mar-lft"
          @click="handleLvcInfo('copy')">
        <i class="fa fa-copy mar-rgt-5"></i>复制</span>
      </p>
    </div>
    <div class="flex flex-center text-center">
      <div class="mar-top">
        <p class="text-sm">方式一：直播二维码（对内）</p>
        <div class="text-center">
          <vue-qr class="view-url-qrcode" :text="lvcInfo.viewUrl" :size="150"></vue-qr>
        </div>
        <!-- <van-button type="primary" size="mini" @click="saveQrCodeImg('view-url-qrcode')">保存图片</van-button> -->
      </div>
      <div class="mar-top" v-show="lvcInfo.openUrl">
        <p class="text-sm">方式二：直播二维码（对外）</p>
        <div class="text-center">
          <vue-qr class="open-url-qrcode" :text="lvcInfo.openUrl" :size="150"></vue-qr>
        </div>
        <!-- <van-button type="primary" size="mini" @click="saveQrCodeImg('open-url-qrcode')">保存图片</van-button> -->
      </div>
    </div>
    
    <div class="mar-top">
      <p class="text-sm">方式{{lvcInfo.openUrl ? '三' : '二'}}：直播链接（对内）</p>
      <van-search v-model="lvcInfo.viewUrl" disabled class="pad-no text-sm bord-all"
                  show-action @search="" left-icon="" shape="square">
        <template #action>
          <div class="text-sm text-primary"
               @click="lvcUrlCopy('viewUrl')"><i class="fa fa-copy mar-rgt-5"></i>复制
          </div>
        </template>
      </van-search>
    </div>
    <div class="mar-top" v-show="lvcInfo.openUrl">
      <p class="text-sm">方式四：直播链接（对外）</p>
      <van-search v-model="lvcInfo.openUrl" disabled class="pad-no text-sm bord-all"
                  show-action @search="" left-icon="" shape="square">
        <template #action>
          <div class="text-sm text-primary"
               @click="lvcUrlCopy('openUrl')"><i class="fa fa-copy mar-rgt-5"></i>复制
          </div>
        </template>
      </van-search>
    </div>
  </div>
</template>

<script>
  import VueQr from 'vue-qr';
  import {meeting} from '../../../server';
  import {commonConfig} from "../../../config/common";
  import {syncHandle, base64ToBlob} from "../../../tools/utils";
  export default {
    components: {VueQr},
    props: {
      show: Boolean,
      mid: String,
      lvcInfo: Object
    },
    data() {
      return {
        password: ''
      }
    },
    computed: {
      showPopup: {
        get() {
          return this.show
        },
        set(val) {
          this.$emit('handle-cancel', val)
        },
      },
    },
    mounted() {
      this.password = this.lvcInfo.password;
    },
    methods: {
      noticeCopy() {
        vtToast("已复制 ~")
      },
      async handleLvcInfo(mode) {
        const data = {
          mid: this.mid, 
          keys: ['password']
        }
        try {
          const {searchLvcInfo: res} = await meeting.queryLvcInfo(this, {queryFilter: data});
          if (res.code === 0) {
            res.data || {}
            const {data = {}} = res;
            switch(mode) {
              case 'look':
                this.password = commonConfig.asteriskReg.test(this.password) ? data.password : this.lvcInfo.password;
                break;
              case 'copy':
                if (data.password) {
                  syncHandle(() => {
                    this.$copyText(data.password).then(() => {
                      this.noticeCopy();
                    }, err => {
                      throw new Error(err);
                    })
                  })
                }
                break;
            }
          }
        } catch(err) {
          throw new Error(err);
        }
      },
      lvcUrlCopy(type) {
        const url = type === 'viewUrl' ? this.lvcInfo.viewUrl : this.lvcInfo.openUrl;
        this.$copyText(url).then(() => {
          this.noticeCopy();
        }, err => {
          throw new Error(err);
        })
      },
      saveQrCodeImg(cls) {
        let imgDom = document.querySelector(`.${cls}`);
        let aLink = document.createElement('a');
        const blob = base64ToBlob(imgDom.src);
        aLink.download = `${cls}.png`;
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
      },
    }
  }
</script>

<style lang="less">
  .lvc-share {
    .van-search__content {
      border-radius: unset !important;
    }
  }
</style>
